<template>
  <div class="page">
    <div class="box">
      <div class="title" style="font-size:18px">填写收货信息</div>
      <input type="text" v-model="name" placeholder="收货人真实姓名">
      <input type="tel" v-model="phone" placeholder="联系电话（11位手机号）" maxlength="11">

      <div class="address-group">
        <div class="dropdown-wrap">
          <input type="text" v-model="province" placeholder="省份"
            @focus="provFocused = true" @blur="onProvBlur"
            @input="filterProv">
          <ul class="dropdown" v-if="provFocused && filteredProvs.length">
            <li v-for="p in filteredProvs" :key="p" @mousedown.prevent="selectProv(p)">{{ p }}</li>
          </ul>
        </div>
        <div class="dropdown-wrap">
          <input type="text" v-model="city" placeholder="城市"
            @focus="cityFocused = true" @blur="onCityBlur"
            @input="filterCity">
          <ul class="dropdown" v-if="cityFocused && filteredCities.length">
            <li v-for="c in filteredCities" :key="c" @mousedown.prevent="selectCity(c)">{{ c }}</li>
          </ul>
        </div>
      </div>

      <textarea v-model="detailAddr" placeholder="详细区县、街道、门牌号" rows="3"></textarea>
      <button :disabled="submitting" @click="submitOrder">
        {{ submitting ? '提交中...' : '确认无误，提交发货' }}
      </button>
    </div>

    <Modal :visible="modal.visible" :title="modal.title" @close="onModalClose">
      <p>{{ modal.msg }}</p>
      <template #footer>
        <button class="modal-btn" @click="onModalClose">确定</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';


const regionData = {
  "北京市": ["东城区","西城区","朝阳区","丰台区","石景山区","海淀区","顺义区","通州区","大兴区","房山区","门头沟区","昌平区","平谷区","密云区","怀柔区","延庆区"],
  "天津市": ["和平区","河东区","河西区","南开区","河北区","红桥区","滨海新区","东丽区","西青区","津南区","北辰区","武清区","宝坻区","宁河区","静海区","蓟州区"],
  "上海市": ["黄浦区","徐汇区","长宁区","静安区","普陀区","虹口区","杨浦区","闵行区","宝山区","嘉定区","浦东新区","金山区","松江区","青浦区","奉贤区","崇明区"],
  "重庆市": ["万州区","涪陵区","渝中区","大渡口区","江北区","沙坪坝区","九龙坡区","南岸区","北碚区","綦江区","大足区","渝北区","巴南区","黔江区","长寿区","江津区","合川区","永川区","南川区","璧山区","铜梁区","潼南区","荣昌区","开州区","梁平区","武隆区"],
  "河北省": ["石家庄市","唐山市","秦皇岛市","邯郸市","邢台市","保定市","张家口市","承德市","沧州市","廊坊市","衡水市"],
  "山西省": ["太原市","大同市","阳泉市","长治市","晋城市","朔州市","晋中市","运城市","忻州市","临汾市","吕梁市"],
  "内蒙古": ["呼和浩特市","包头市","乌海市","赤峰市","通辽市","鄂尔多斯市","呼伦贝尔市","巴彦淖尔市","乌兰察布市"],
  "辽宁省": ["沈阳市","大连市","鞍山市","抚顺市","本溪市","丹东市","锦州市","营口市","阜新市","辽阳市","盘锦市","铁岭市","朝阳市","葫芦岛市"],
  "吉林省": ["长春市","吉林市","四平市","辽源市","通化市","白山市","松原市","白城市","延边州"],
  "黑龙江省": ["哈尔滨市","齐齐哈尔市","鸡西市","鹤岗市","双鸭山市","大庆市","伊春市","佳木斯市","七台河市","牡丹江市","黑河市","绥化市"],
  "江苏省": ["南京市","无锡市","徐州市","常州市","苏州市","南通市","连云港市","淮安市","盐城市","扬州市","镇江市","泰州市","宿迁市"],
  "浙江省": ["杭州市","宁波市","温州市","嘉兴市","湖州市","绍兴市","金华市","衢州市","舟山市","台州市","丽水市"],
  "安徽省": ["合肥市","芜湖市","蚌埠市","淮南市","马鞍山市","淮北市","铜陵市","安庆市","黄山市","滁州市","阜阳市","宿州市","六安市","亳州市","池州市","宣城市"],
  "福建省": ["福州市","厦门市","莆田市","三明市","泉州市","漳州市","南平市","龙岩市","宁德市"],
  "江西省": ["南昌市","景德镇市","萍乡市","九江市","抚州市","鹰潭市","赣州市","吉安市","宜春市","新余市","上饶市"],
  "山东省": ["济南市","青岛市","淄博市","枣庄市","东营市","烟台市","潍坊市","济宁市","泰安市","威海市","日照市","临沂市","德州市","聊城市","滨州市","菏泽市"],
  "河南省": ["郑州市","开封市","洛阳市","平顶山市","安阳市","鹤壁市","新乡市","焦作市","濮阳市","许昌市","漯河市","三门峡市","南阳市","商丘市","信阳市","周口市","驻马店市"],
  "湖北省": ["武汉市","黄石市","十堰市","宜昌市","襄阳市","鄂州市","荆门市","孝感市","荆州市","黄冈市","咸宁市","随州市","恩施州"],
  "湖南省": ["长沙市","株洲市","湘潭市","衡阳市","邵阳市","岳阳市","常德市","张家界市","益阳市","郴州市","永州市","怀化市","娄底市","湘西州"],
  "广东省": ["广州市","韶关市","深圳市","珠海市","汕头市","佛山市","江门市","湛江市","茂名市","肇庆市","惠州市","梅州市","汕尾市","河源市","阳江市","清远市","东莞市","中山市","潮州市","揭阳市","云浮市"],
  "广西": ["南宁市","柳州市","桂林市","梧州市","北海市","防城港市","钦州市","贵港市","玉林市","百色市","贺州市","河池市","来宾市","崇左市"],
  "海南省": ["海口市","三亚市","三沙市","儋州市"],
  "四川省": ["成都市","自贡市","攀枝花市","泸州市","德阳市","绵阳市","广元市","遂宁市","内江市","乐山市","南充市","眉山市","宜宾市","广安市","达州市","雅安市","巴中市","资阳市"],
  "贵州省": ["贵阳市","六盘水市","遵义市","安顺市","毕节市","铜仁市","黔西南州","黔东南州","黔南州"],
  "云南省": ["昆明市","曲靖市","玉溪市","保山市","昭通市","丽江市","普洱市","临沧市","楚雄州","红河州","文山州","西双版纳州","大理州","德宏州","怒江州","迪庆州"],
  "西藏": ["拉萨市","日喀则市","昌都市","林芝市","山南市","那曲市","阿里地区"],
  "陕西省": ["西安市","铜川市","宝鸡市","咸阳市","渭南市","延安市","汉中市","榆林市","安康市","商洛市"],
  "甘肃省": ["兰州市","嘉峪关市","金昌市","白银市","天水市","武威市","张掖市","平凉市","酒泉市","庆阳市","定西市","陇南市","临夏州","甘南州"],
  "青海省": ["西宁市","海东市","海北州","黄南州","海南州","果洛州","玉树州","海西州"],
  "宁夏": ["银川市","石嘴山市","吴忠市","固原市","中卫市"],
  "新疆": ["乌鲁木齐市","克拉玛依市","吐鲁番市","哈密市","昌吉州","博尔塔拉州","巴音郭楞州","阿克苏地区","克孜勒苏州","喀什地区","和田地区","伊犁州","塔城地区","阿勒泰地区"],
  "台湾省": ["台北市","高雄市","台中市","台南市","基隆市","新竹市","嘉义市"],
  "香港": ["中西区","湾仔区","东区","南区","油尖旺区","深水埗区","九龙城区","黄大仙区","观塘区","荃湾区","屯门区","元朗区","北区","大埔区","沙田区","西贡区","离岛区"],
  "澳门": ["花地玛堂区","圣安多尼堂区","大堂区","望德堂区","风顺堂区","嘉模堂区","路凼填海区"]
};

const provinces = Object.keys(regionData);

export default {
  name: 'ShipInfoPage',
  components: { Modal },
  data() {
    return {
      name: '',
      phone: '',
      province: '',
      city: '',
      detailAddr: '',
      submitting: false,
      card: '',
      pkg: '',
      modal: { visible: false, title: '', msg: '', onOk: null },
      provFocused: false,
      cityFocused: false,
      filteredProvs: provinces,
      filteredCities: []
    };
  },
  created() {
    this.card = sessionStorage.getItem('card') || '';
    this.pkg = sessionStorage.getItem('pkg') || '';
    if (!this.card || !this.pkg) {
      this.showModal('提示', '请按顺序操作', () => this.$router.replace('/verify'));
    }
  },
  methods: {
    showModal(title, msg, onOk) {
      this.modal = { visible: true, title, msg, onOk: onOk || null };
    },
    onModalClose() {
      this.modal.visible = false;
      if (this.modal.onOk) this.modal.onOk();
    },
    filterProv() {
      const kw = this.province.trim();
      this.filteredProvs = provinces.filter(p => p.includes(kw));
    },
    selectProv(p) {
      this.province = p;
      this.city = '';
      this.filteredCities = regionData[p] || [];
      this.provFocused = false;
    },
    onProvBlur() {
      setTimeout(() => { this.provFocused = false; }, 200);
    },
    filterCity() {
      const kw = this.city.trim();
      const cities = regionData[this.province] || [];
      this.filteredCities = cities.filter(c => c.includes(kw));
    },
    selectCity(c) {
      this.city = c;
      this.cityFocused = false;
    },
    onCityBlur() {
      setTimeout(() => { this.cityFocused = false; }, 200);
    },
submitOrder() {
      const name = this.name.trim();
      const phone = this.phone.trim();
      const province = this.province.trim();
      const city = this.city.trim();
      const detailAddr = this.detailAddr.trim();

      if (!/^1\d{10}$/.test(phone)) {
        this.showModal('提示', '请输入正确的11位手机号码');
        return;
      }
      if (!name || !province || !city || !detailAddr) {
        this.showModal('提示', '请将收货信息填写完整！');
        return;
      }

      sessionStorage.setItem('shipName', name);
      sessionStorage.setItem('shipPhone', phone);
      sessionStorage.setItem('shipProvince', province);
      sessionStorage.setItem('shipCity', city);
      sessionStorage.setItem('shipDetailAddr', detailAddr);

      this.$router.push('/confirm');
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  padding: 20px 15px;
}
.box {
  max-width: 420px;
  margin: 0 auto;
  background: #fff;
  padding: 25px 20px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
  border-top: 5px solid var(--color-primary);
}
.title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
  letter-spacing: 1px;
}
input, textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  margin: 8px 0;
  border: 1px solid #eaeaea;
  background-color: #fafbfc;
  border-radius: 10px;
  font-size: 15px;
  color: #333;
  transition: all 0.3s ease;
  outline: none;
}
input:focus, textarea:focus {
  border-color: var(--color-primary-light);
  background-color: #fff;
  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);
}
textarea {
  resize: none;
}
.address-group {
  display: flex;
  gap: 8px;
}
.address-group > * {
  flex: 1;
}
.address-group input {
  padding: 14px 8px;
}
.dropdown-wrap {
  position: relative;
}
.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 500;
  list-style: none;
  margin: 2px 0 0;
  padding: 4px 0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.dropdown li {
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background 0.15s ease;
}
.dropdown li:hover {
  background: var(--color-primary-soft);
  color: var(--color-primary);
}
button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, var(--color-primary-light), var(--color-primary));
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  margin-top: 15px;
  cursor: pointer;
  box-shadow: 0 4px 15px var(--color-primary-shadow);
  transition: all 0.2s ease;
}
button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--color-primary-shadow-hover);
}
button:disabled {
  opacity: 0.6;
  transform: none;
  cursor: not-allowed;
}
.modal-btn {
  width: auto;
  padding: 10px 32px;
  margin-top: 0;
}
</style>
